import React from 'react';
import './DashboardButton.scss';
import {PropTypes} from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const DashboardButton = (props) => (
    <div className="hrb-dashboard-button-container">
      <div className="hrb-dashboard-button-container-highlight" onClick={props.onClick}>
        <div className="hrb-dashboard-button-content">
          {props.children}
        </div>
        <div className="hrb-dashboard-button-arrow">
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>

    </div>
);

DashboardButton.propTypes = {
  onClick: PropTypes.func
};

export default DashboardButton;